export default {
    path : "warehouse-carrier-recycled",
    name : "warehouse-carrier-recycled",
    meta : {
        title : "载体回收站"
    },
    component: () => import('@/pages/warehouse/recycledCarrier/Index'),
    redirect: {
        name : "warehouse-carrier-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-carrier-recycled-whole',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-carrier-recycled-recent',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-carrier-recycled-atme',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-carrier-recycled-meat',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-carrier-recycled-reply',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-carrier-recycled-search',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/recycledcarrier/index.js